import apptsTypes from './appts.types';

export const addApptStart = apptData => ({
  type: apptsTypes.ADD_NEW_APPT_START,
  payload: apptData
});
export const updateApptStart = (apptData) => ({
  type: apptsTypes.UPDATE_APPT_START,
  payload: apptData
});

export const fetchApptsStart = (filters={}) => ({
	type: apptsTypes.FETCH_APPTS_START,
	payload: filters
});  

export const fetchAllApptsStart = (filters={}) => ({
	type: apptsTypes.FETCH_ALL_APPTS_START,
	payload: filters
});  

export const setAppts = appts => ({
  type: apptsTypes.SET_APPTS,
  payload: appts
});

export const deleteApptStart = apptID => ({
  type: apptsTypes.DELETE_APPT_START,
  payload: apptID
});

export const fetchApptStart = apptID => ({
  type: apptsTypes.FETCH_APPT_START,
  payload: apptID
});

export const setAppt = appt => ({
  type: apptsTypes.SET_APPT,
  payload: appt
});